import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ericmalek/Desktop/Portfolio/ej-claude/ejclaude/app/about/AboutClient.tsx");
